import { AbstractResource } from '../abstract';

export class StaticResource extends AbstractResource {
    private _creativeType: string | null;
    constructor() {
        super();
        this._creativeType = null;
    }

    get creativeType() {
        return this._creativeType;
    }

    set creativeType(value) {
        this._creativeType = value;
    }

    get $type() {
        return 'StaticResource';
    }
}
